<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home-page']" titlePrefix="Pixeloogic – Smart Advertising Solutions for Global Growth "
    metaDescription="Connect with premium traffic, AI-powered optimization, and dedicated support. Our global advertising platform helps advertisers and publishers achieve transparent, scalable, and performance-driven results.">

    <div class="banner-section">
      <div class="banner-section__content">
        <h1 class="banner-section__title">Kickstart Your Advertising Journey</h1>
        <p class="banner-section__subtitle">Simplify campaign management and drive higher ROI with
          our advanced ad trading platform.</p>
        <div class="banner-section__cta" @click="scrollToContact">CONTACT <img
            src="@/assets/banner-contact-arrow.svg" alt=">" /></div>
      </div>
      <div class="banner-section__image">
        <img v-if="deviceType === 'mobile'" src="@/assets/banner-m.png" alt="Advertising Journey" />
        <img v-else src="@/assets/banner.png" alt="Advertising Journey" />
      </div>
    </div>

    <div class="services-section">
      <h2 class="services-section__title">Our Services</h2>
      <p class="services-section__subtitle">We deliver premium advertising solutions to help advertisers expand reach, optimize campaigns, and achieve measurable results.</p>
      <div class="services-section__cards">
        <div class="service-card service-card--green">
          <div class="service-card-img">
            <img src="@/assets/service-1.svg" alt="Global Premium Ad Network" />
          </div>
          <h3>Global Premium Ad Network</h3>
          <p>Access targeted audiences in 180+ countries with a variety of ad formats, including display, video, and push notifications. Our network guarantees brand-safe placements, broad reach, and performance-driven outcomes.</p>
        </div>
        <div class="service-card service-card--blue">
          <div class="service-card-img">
            <img src="@/assets/service-2.svg" alt="Advanced Analytics & Campaign Optimization" />
          </div>
          <h3>Advanced Analytics & Campaign Optimization</h3>
          <p>Track campaigns in real time with AI-powered bidding, detailed analytics, and anti-fraud protections. Monitor clicks, impressions, and conversions to ensure maximum ROI.</p>
        </div>
        <div class="service-card service-card--red">
          <div class="service-card-img">
            <img src="@/assets/service-3.svg" alt="Tailored Solutions & Expert Support" />
          </div>
          <h3>Tailored Solutions & Expert Support</h3>
          <p>Receive dedicated account management, customized campaign strategies, and seamless API integration. Whether advertiser or publisher, we provide solutions aligned with your goals.</p>
        </div>
      </div>
    </div>

    <div class="story-section">
      <div class="story-section__content">
        <h2 class="story-section__title">Our Story</h2>
        <h3 class="story-section__heading">We believe advertising should be transparent, efficient, and performance-focused.</h3>
      </div>
      <div class="story-swich-content">
        <div class="story-section__left">
          <img src="@/assets/story-1.png" alt="Our Story Image 1"
            class="story-section__image--main">
        </div>
        <div class="story-section__right">
          <div class="story-section__right-images">
            <img src="@/assets/story-2.png" alt="Our Story Image 2"
              class="story-section__image--top">
            <img src="@/assets/story-3.png" alt="Our Story Image 3"
              class="story-section__image--bottom">
          </div>
          <div class="story-section__content">
            <p class="story-section__text">
              Started by a team of ad tech specialists, we’ve evolved from a small platform into a global partner for advertisers and publishers. What makes us different is our data-driven technology, real industry experience, and long-term partnership mindset. Whether you're seeking premium traffic or high-quality offers, we help you grow with clarity and confidence.
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="stats-section">
      <div class="stat">
        <p class="stat__number">60+</p>
        <p class="stat__description">Markets Connected — Powering campaigns across North America, Europe, and Asia.</p>
      </div>
      <div class="stat">
        <p class="stat__number">96%</p>
        <p class="stat__description">Client Retention — Built on trust, performance, and sustainable growth.</p>
      </div>
      <div class="stat">
        <p class="stat__number">1,200+</p>
        <p class="stat__description">Active Partners — Trusted by brands, agencies, and media buyers worldwide.</p>
      </div>
    </div>

    <div class="why-choose-us-section">
      <h2 class="why-choose-us-section__title">Why Choose Us</h2>
      <h3 class="why-choose-us-section__heading">  We focus on more than impressions — we help you build sustainable, long-term growth.</h3>
      <div class="why-choose-us-section__cards">
        <div class="why-card">
          <div class="why-card__icon icon-1">
            <img src="@/assets/why-icon-1.svg" alt="Performance That Matters">
          </div>
          <div class="why-card__content">
            <h4>Performance That Matters</h4>
            <p>Smart targeting and real-time optimization deliver measurable results, not just clicks.</p>
          </div>
        </div>
        <div class="why-card">
          <div class="why-card__icon icon-2">
            <img src="@/assets/why-icon-2.svg" alt="Global Network, Local Insight">
          </div>
          <div class="why-card__content">
            <h4>Global Network, Local Insight</h4>
            <p>Tap into quality traffic from 50+ markets, guided by region-specific strategies.</p>
          </div>
        </div>
        <div class="why-card">
          <div class="why-card__icon icon-3">
            <img src="@/assets/why-icon-3.svg" alt="Smart Tech, Safer Campaigns">
          </div>
          <div class="why-card__content">
            <h4>Smart Tech, Safer Campaigns</h4>
            <p>AI optimization, automated scaling, and fraud protection ensure every dollar works harder.</p>
          </div>
        </div>
        <div class="why-card">
          <div class="why-card__icon icon-4">
            <img src="@/assets/why-icon-4.svg" alt="Partners, Not Just Clients">
          </div>
          <div class="why-card__content">
            <h4>Partners, Not Just Clients</h4>
            <p>Personal support, clear communication, and shared goals — your success is ours.</p>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common],
  data () {
    return {

    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  methods: {
    scrollToSection (hash) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    scrollToContact () {
      const contactElement = document.getElementById('contact');
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

  }
};
</script>

